import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="beitragsuebersicht"
export default class extends Controller {
	static targets = ["labelBetragVorsorge", "inputBetragVorsorge"]

	connect() {}

	updateLabel({ currentTarget, params }) {
		const label = this.element.querySelector(`[data-label-${params.labelname}]`)

		if (!label) return

		currentTarget.checked ? label.classList.remove("hidden") : label.classList.add("hidden")

		this.updateBetragVorsorge()
		this.updateBeitragsuebersicht()
	}

	updateLabelBetrag({ currentTarget, params }) {
		const labelBetrag = this.element.querySelector(`[data-label-${params.label}] > div`)

		if (!labelBetrag) return

		const inputFelder = this.element.querySelectorAll(`[data-beitragsuebersicht-label-param='${params.label}']`)
		let summe = 0.0

		inputFelder.forEach((e) => {
			summe += currencyStringToFloat(e.value)
		})

		// const float = currencyStringToFloat(currentTarget.value)
		labelBetrag.innerHTML = currency(summe, 2)

		this.updateBetragVorsorge()
	}

	// Private Methods

	updateBetragVorsorge() {
		const gesamtBetrag = this.element.querySelector("[data-label-gesamt] > div")
		const beitragsbefreiungBetrag = this.element.querySelector("[data-label-beitragsbefreiung]:not(.hidden) > div")
		const burenteBetrag = this.element.querySelector("[data-label-burente]:not(.hidden) > div")
		const risikoBetrag = this.element.querySelector("[data-label-risiko]:not(.hidden) > div")
		const todesfallBetrag = this.element.querySelector("[data-label-todesfall]:not(.hidden) > div")

		const gesamt = currencyStringToFloat(gesamtBetrag.innerHTML)
		const beitragsbefreiung = beitragsbefreiungBetrag ? currencyStringToFloat(beitragsbefreiungBetrag.innerHTML) : 0
		const burente = burenteBetrag ? currencyStringToFloat(burenteBetrag.innerHTML) : 0
		const risiko = risikoBetrag ? currencyStringToFloat(risikoBetrag.innerHTML) : 0
		const todesfall = todesfallBetrag ? currencyStringToFloat(todesfallBetrag.innerHTML) : 0

		const vorsorge = gesamt - beitragsbefreiung - burente - risiko - todesfall

		this.labelBetragVorsorgeTarget.innerHTML = currency(vorsorge, 2)
		this.inputBetragVorsorgeTarget.value = vorsorge.toFixed(2)
	}

	updateBeitragsuebersicht() {
		const beitragsbefreiungLabel = this.element.querySelector("[data-label-beitragsbefreiung]:not(.hidden)")
		const burenteLabel = this.element.querySelector("[data-label-burente]:not(.hidden)")
		const risikoLabel = this.element.querySelector("[data-label-risiko]:not(.hidden)")
		const todesfallLabel = this.element.querySelector("[data-label-todesfall]:not(.hidden)")

		const uebersicht = this.element.querySelector("[data-label-uebersicht]")

		if (!uebersicht) return

		if (beitragsbefreiungLabel || burenteLabel || risikoLabel || todesfallLabel) {
			// Beitragsübersicht anzeigen
			uebersicht.classList.remove("hidden")
		} else {
			// Beitragsübersicht NICHT anzeigen
			uebersicht.classList.add("hidden")
		}
	}
}
